"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var loadActiveChallenges = function loadActiveChallenges(payload) {
  return {
    type: 'LOAD_ACTIVE_CHALLENGES',
    payload: payload
  };
};

var loadActiveChallengesSuccess = function loadActiveChallengesSuccess(data) {
  return {
    type: 'LOAD_ACTIVE_CHALLENGES_SUCCESS',
    payload: data
  };
};

var loadActiveChallengesError = function loadActiveChallengesError(error) {
  return {
    type: 'LOAD_ACTIVE_CHALLENGES_ERROR',
    payload: {
      error: error
    }
  };
};

var resetActiveChallenges = function resetActiveChallenges() {
  return {
    type: 'RESET_ACTIVE_CHALLENGES'
  };
};

var resetPromoteChallenges = function resetPromoteChallenges() {
  return {
    type: 'RESET_PROMOTE_CHALLENGES'
  };
};

var loadCurrentChallenges = function loadCurrentChallenges(payload) {
  return {
    type: 'LOAD_CURRENT_CHALLENGES',
    payload: payload
  };
};

var loadCurrentChallengesSuccess = function loadCurrentChallengesSuccess(data) {
  return {
    type: 'LOAD_CURRENT_CHALLENGES_SUCCESS',
    payload: data
  };
};

var loadCurrentChallengesError = function loadCurrentChallengesError(error) {
  return {
    type: 'LOAD_CURRENT_CHALLENGES_ERROR',
    payload: {
      error: error
    }
  };
};

var resetCurrentChallenges = function resetCurrentChallenges() {
  return {
    type: 'RESET_CURRENT_CHALLENGES'
  };
};

var loadNextChallenges = function loadNextChallenges(payload) {
  return {
    type: 'LOAD_NEXT_CHALLENGES',
    payload: payload
  };
};

var loadNextChallengesSuccess = function loadNextChallengesSuccess(data) {
  return {
    type: 'LOAD_NEXT_CHALLENGES_SUCCESS',
    payload: data
  };
};

var loadNextChallengesError = function loadNextChallengesError(error) {
  return {
    type: 'LOAD_NEXT_CHALLENGES_ERROR',
    payload: {
      error: error
    }
  };
};

var resetNextChallenges = function resetNextChallenges() {
  return {
    type: 'RESET_NEXT_CHALLENGES'
  };
};

var loadFinishedChallenges = function loadFinishedChallenges(payload) {
  return {
    type: 'LOAD_FINISHED_CHALLENGES',
    payload: payload
  };
};

var loadFinishedChallengesSuccess = function loadFinishedChallengesSuccess(data) {
  return {
    type: 'LOAD_FINISHED_CHALLENGES_SUCCESS',
    payload: data
  };
};

var loadFinishedChallengesError = function loadFinishedChallengesError(error) {
  return {
    type: 'LOAD_FINISHED_CHALLENGES_ERROR',
    payload: {
      error: error
    }
  };
};

var resetFinishedChallenges = function resetFinishedChallenges() {
  return {
    type: 'RESET_FINISHED_CHALLENGES'
  };
};

var loadRegisteredCurrentChallenges = function loadRegisteredCurrentChallenges(payload) {
  return {
    type: 'LOAD_REGISTERED_CURRENT_CHALLENGES',
    payload: payload
  };
};

var loadRegisteredCurrentChallengesSuccess = function loadRegisteredCurrentChallengesSuccess(data) {
  return {
    type: 'LOAD_REGISTERED_CURRENT_CHALLENGES_SUCCESS',
    payload: data
  };
};

var loadRegisteredCurrentChallengesError = function loadRegisteredCurrentChallengesError(error) {
  return {
    type: 'LOAD_REGISTERED_CURRENT_CHALLENGES_ERROR',
    payload: {
      error: error
    }
  };
};

var resetRegisteredCurrentChallenges = function resetRegisteredCurrentChallenges() {
  return {
    type: 'RESET_REGISTERED_CURRENT_CHALLENGES'
  };
};

var loadRegisteredFinishedChallenges = function loadRegisteredFinishedChallenges(payload) {
  return {
    type: 'LOAD_REGISTERED_FINISHED_CHALLENGES',
    payload: payload
  };
};

var loadRegisteredFinishedChallengesSuccess = function loadRegisteredFinishedChallengesSuccess(data) {
  return {
    type: 'LOAD_REGISTERED_FINISHED_CHALLENGES_SUCCESS',
    payload: data
  };
};

var loadRegisteredFinishedChallengesError = function loadRegisteredFinishedChallengesError(error) {
  return {
    type: 'LOAD_REGISTERED_FINISHED_CHALLENGES_ERROR',
    payload: {
      error: error
    }
  };
};

var resetRegisteredFinishedChallenges = function resetRegisteredFinishedChallenges() {
  return {
    type: 'RESET_REGISTERED_FINISHED_CHALLENGES'
  };
};

var loadPromoteChallenges = function loadPromoteChallenges(payload) {
  return {
    type: 'LOAD_PROMOTE_CHALLENGES',
    payload: payload
  };
};

var loadPromoteChallengesSuccess = function loadPromoteChallengesSuccess(data) {
  return {
    type: 'LOAD_PROMOTE_CHALLENGES_SUCCESS',
    payload: data
  };
};

var loadPromoteChallengesError = function loadPromoteChallengesError(error) {
  return {
    type: 'LOAD_PROMOTE_CHALLENGES_ERROR',
    payload: {
      error: error
    }
  };
};

var resetAllChallenges = function resetAllChallenges() {
  return {
    type: 'RESET_ALL_CHALLENGES'
  };
};

var _default = {
  loadActiveChallenges: loadActiveChallenges,
  loadActiveChallengesSuccess: loadActiveChallengesSuccess,
  loadActiveChallengesError: loadActiveChallengesError,
  resetActiveChallenges: resetActiveChallenges,
  loadCurrentChallenges: loadCurrentChallenges,
  loadCurrentChallengesSuccess: loadCurrentChallengesSuccess,
  loadCurrentChallengesError: loadCurrentChallengesError,
  resetCurrentChallenges: resetCurrentChallenges,
  loadNextChallenges: loadNextChallenges,
  loadNextChallengesSuccess: loadNextChallengesSuccess,
  loadNextChallengesError: loadNextChallengesError,
  resetNextChallenges: resetNextChallenges,
  loadFinishedChallenges: loadFinishedChallenges,
  loadFinishedChallengesSuccess: loadFinishedChallengesSuccess,
  loadFinishedChallengesError: loadFinishedChallengesError,
  resetFinishedChallenges: resetFinishedChallenges,
  loadRegisteredCurrentChallenges: loadRegisteredCurrentChallenges,
  loadRegisteredCurrentChallengesSuccess: loadRegisteredCurrentChallengesSuccess,
  loadRegisteredCurrentChallengesError: loadRegisteredCurrentChallengesError,
  resetRegisteredCurrentChallenges: resetRegisteredCurrentChallenges,
  loadRegisteredFinishedChallenges: loadRegisteredFinishedChallenges,
  loadRegisteredFinishedChallengesSuccess: loadRegisteredFinishedChallengesSuccess,
  loadRegisteredFinishedChallengesError: loadRegisteredFinishedChallengesError,
  resetRegisteredFinishedChallenges: resetRegisteredFinishedChallenges,
  resetPromoteChallenges: resetPromoteChallenges,
  loadPromoteChallenges: loadPromoteChallenges,
  loadPromoteChallengesSuccess: loadPromoteChallengesSuccess,
  loadPromoteChallengesError: loadPromoteChallengesError,
  resetAllChallenges: resetAllChallenges
};
exports["default"] = _default;
//# sourceMappingURL=actions.js.map